"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var React = _interopRequireWildcard(require("react"));
var _modal_with_submit_actions = _interopRequireDefault(require("./modal_with_submit_actions"));
var _use_modal = _interopRequireDefault(require("./use_modal"));
var _typography = _interopRequireDefault(require("../typography"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
// @ts-expect-error - TS7016 - Could not find a declaration file for module './use_modal'. 'src/azalea/components/modals/use_modal.js' implicitly has an 'any' type.

var ConfirmModal = function ConfirmModal(props) {
  var children = props.children,
    confirmText = props.confirmText,
    onConfirm = props.onConfirm,
    modalContent = props.modalContent,
    title = props.title,
    fullWidth = props.fullWidth,
    maxWidth = props.maxWidth,
    submitText = props.submitText,
    cancelText = props.cancelText,
    hideCancelButton = props.hideCancelButton,
    modalBodyOverflow = props.modalBodyOverflow;
  var _useModal = (0, _use_modal["default"])(false),
    _useModal2 = (0, _slicedToArray2["default"])(_useModal, 3),
    open = _useModal2[0],
    openModal = _useModal2[1],
    closeModal = _useModal2[2];
  function confirm() {
    onConfirm();
    closeModal();
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, children && /*#__PURE__*/React.cloneElement(children, {
    onClick: openModal
  }), /*#__PURE__*/React.createElement(_modal_with_submit_actions["default"], {
    open: open,
    closeModal: closeModal,
    onSubmit: confirm,
    title: title,
    fullWidth: fullWidth,
    maxWidth: maxWidth,
    dividers: false,
    submitText: submitText,
    cancelText: cancelText,
    hideCancelButton: hideCancelButton,
    draggable: false,
    modalBodyOverflow: modalBodyOverflow,
    fancy: true
  }, confirmText ? /*#__PURE__*/React.createElement(_typography["default"], {
    type: "p"
  }, confirmText) : modalContent));
};
var _default = exports["default"] = ConfirmModal;
ConfirmModal.defaultProps = {
  open: false,
  fullScreen: false,
  fullWidth: true,
  maxWidth: 'sm',
  displayXIcon: true
};